document.addEventListener("DOMContentLoaded", function () {
  const tabs = document.querySelectorAll('.postTabs__tab');
  const postCopy = document.querySelector('.postBody__copy');

  if (!tabs.length || !postCopy) return;

  tabs.forEach(tab => {
    tab.addEventListener('click', function (e) {
      e.preventDefault();

      // Get the target section ID from aria-controls
      const targetId = this.getAttribute('aria-controls');
      const targetSection = document.getElementById(targetId);

      if (!targetSection) return;

      // Remove active class and update aria-selected for all tabs
      tabs.forEach(t => {
        t.classList.remove('postTabs__tab--active');
        t.setAttribute('aria-selected', 'false');
      });

      // Add active class and update aria-selected for clicked tab
      this.classList.add('postTabs__tab--active');
      this.setAttribute('aria-selected', 'true');

      // Get header height for offset
      const isDesktop = window.innerWidth >= 1200;
      const header = isDesktop
        ? document.querySelector('.desktopHeader')
        : document.querySelector('.mobileHeader');
      const headerHeight = header ? header.offsetHeight : 0;

      // Get postTabs height and margin-bottom for offset
      const postTabs = document.querySelector('.postTabs');
      const postTabsHeight = postTabs ? postTabs.offsetHeight : 0;
      const postTabsMargin = postTabs ? parseInt(window.getComputedStyle(postTabs).marginBottom) : 0;

      // Scroll to the target section with offset
      const totalOffset = headerHeight + postTabsHeight + postTabsMargin;
      const targetPosition = targetSection.getBoundingClientRect().top + window.pageYOffset - totalOffset;
      window.scrollTo({
        top: targetPosition,
        behavior: 'smooth'
      });
    });
  });
});
